export default type => {
	// const issueTypes = [30, 31, 32, 33, 34, 35];
	const issueTypes = [50, 51, 52, 53, 54, 55, 56, 64];
	return issueTypes.includes(type);
};



// WEBPACK FOOTER //
// ./helperfunctions/isIssue.js